(() => {
  const PAUSE_ICON = '❙❙';
  const PLAY_ICON = '▶';

  const setState = (button, playing) => {
    button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    button.textContent = playing ? PAUSE_ICON : PLAY_ICON;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.banner__video-toggle');
    if (!button) return;
    const video = button.closest('.banner__media')?.querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.play();
      setState(button, true);
    } else {
      video.pause();
      setState(button, false);
    }
  });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.banner__media video[autoplay]').forEach((video) => {
      video.pause();
      const button = video.closest('.banner__media')?.querySelector('.banner__video-toggle');
      if (button) setState(button, false);
    });
  }
})();
